import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import { 
  Card, 
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableRow, 
  TableHead,
  TableContainer
} from '@material-ui/core'; 
 
import {urls} from 'utils/url'
import FetchAuth from 'utils/fetch'
import { pveType, pveUrls } from 'utils/pveUrl';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  container: {
    maxHeight: 1000
  }
}));
 

const PlayerEquipment = props => {
  const { id, className, ...rest } = props;

  const classes = useStyles(); 
  const [eqs,setPlayerEquipment] = useState([]);
  const [titleDesp, setDesp] = useState("");
  useEffect(()=>{
    FetchAuth(pveUrls.playerEquipment.path(id),{},pveUrls.playerEquipment.method, pveType). 
    then((rv)=>{
      let data = rv.Data.sort(function(a, b) {return b.power - a.power;});
      setPlayerEquipment(data);
      if (data.length > 0) {
        let desp = "   [总数:" + data.length + ", 最高战力:" + data[0].power + "]";
        setDesp(desp);
      }
    })
    
  },[id])
  return (
    <Card>
    <CardHeader 
      title={"装备" + titleDesp}
    />
    <Divider />
    <CardContent className={classes.content}>
      <PerfectScrollbar>
        <TableContainer className={classes.container}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>  
                <TableCell>ID</TableCell>
                <TableCell>装备ID</TableCell>
                <TableCell>名称</TableCell>
                <TableCell>品质</TableCell>
                <TableCell>强化等级</TableCell>
                <TableCell>战力值</TableCell>
                <TableCell>基础属性</TableCell>
                <TableCell>稀有属性</TableCell>
                <TableCell>套装属性</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {eqs.map(eq => (
                <TableRow
                  hover
                  key={eq.id}
                  selected={eqs.indexOf(eq.id) !== -1}
                > 
                  <TableCell>{eq.id}</TableCell>
                  <TableCell>{eq.eqID}</TableCell>
                  <TableCell>{eq.name}  </TableCell>
                  <TableCell>{eq.quality}</TableCell> 
                  <TableCell>{eq.level}</TableCell>
                  <TableCell>{eq.power}</TableCell>
                  <TableCell>{eq.baseAttrs.map((base, idx) => (<span key={idx}><br/>{base}</span>))}</TableCell>
                  <TableCell>{eq.extraAttrs.map((base, idx) => (<span key={idx}><br/>{base}</span>))}  </TableCell>
                  <TableCell>{eq.suitAttrs.map((base, idx) => (<span key={idx}><br/>{base}</span>))}</TableCell> 
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </PerfectScrollbar>
    </CardContent> 
  </Card>
  );
};

PlayerEquipment.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
};

export default PlayerEquipment;
